import { useGQL } from 'services/gql';
import { breakoutRoomInviteSchema } from './breakoutRoomInviteSchema';
import { breakoutRoomSchema } from './../breakoutRoom/breakoutRoomSchema';
import { userSchema } from '../user/userSchema';
import { brandSchema } from '../brand/brandSchema';
/**
 * voglio recuperare anche le info relative alla breakoutRoom
 */
const listUserInvitationsQuery = /* GraphQL */ `
    query listUserInvitationsQuery($id: ID!, $nextToken: String){
        getUser(id: $id){
            myBreakoutRoomInvitations(nextToken: $nextToken) {
                nextToken
                items {
                   ${breakoutRoomInviteSchema} 
                   breakoutRoom {
                       ${breakoutRoomSchema}
                       brand {
                         ${brandSchema}
                       }
                   }
                }
            }            
        }
    }
`;

const listBreakoutRoomInvitationsQuery = /* GraphQL */ `
    query listBreakoutRoomInvitationsQuery($id: ID!, $nextToken: String){
        getBreakoutRoom(id: $id){
          brand {
            id
            name
          }
          invitations(nextToken: $nextToken) {
              nextToken
              items {
                  ${breakoutRoomInviteSchema}
                  user {
                    ${userSchema}
                  }
              }
          }
          speakers {
            items {
              coverImage
              familyName
              givenName
              id
            }
          }          
        }
    }
`;

const createResultSchema = /* GraphQL */ `
  ${breakoutRoomInviteSchema}
  user {
    ${userSchema}
  }
`;

export const useBreakoutRoomInviteGql = () => {
  const {
    createMutation,
    createMultipleMutation,
    updateMutation,
    updateMultipleMutation,
    deleteMutation,
    deleteMultipleMutation,
    sendQuery,
  } = useGQL('breakoutRoomInvite');

  //QUERY
  const listUserInvitations = (id) =>
    sendQuery('get-by-email', listUserInvitationsQuery, { id }, true);
  const listBreakoutRoomInvitations = (breakoutRoomId) =>
    sendQuery(
      'get-by-breakout-room',
      listBreakoutRoomInvitationsQuery,
      {
        id: breakoutRoomId,
      },
      true
    );

  //MUTATION
  const create = (input) => createMutation(input);
  const createMultiple = (inputList) => createMultipleMutation(inputList);
  const createAndFetchAllData = (input) =>
    createMutation(input, createResultSchema);
  const createMultipleAndFetchAllData = (inputList) =>
    createMultipleMutation(inputList, createResultSchema);
  const update = (input) => updateMutation(input);
  const updateMultiple = (inputList) => updateMultipleMutation(inputList);
  const remove = (input) => deleteMutation(input);
  const removeMultiple = (inputList) => deleteMultipleMutation(inputList);

  return {
    listUserInvitations,
    listBreakoutRoomInvitations,
    create,
    createMultiple,
    createAndFetchAllData,
    createMultipleAndFetchAllData,
    update,
    updateMultiple,
    remove,
    removeMultiple,
  };
};
